export default __webpack_public_path__ + "static/media/Heart Icon - Selected.12c1efdb.svg";